declare const utils: any;

$(function () {

    const honors = [{
            year: 2000,
            tilte: "Upgrade to 2000",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2003,
            tilte: "Upgrade to 2003",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2004,
            tilte: "Upgrade to 2004",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2007,
            tilte: "Upgrade to 2007",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2009,
            tilte: "Upgrade to 2009",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2010,
            tilte: "Upgrade to 2010",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2013,
            tilte: "Upgrade to 2013",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2016,
            tilte: "Upgrade to 2016",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2017,
            tilte: "Upgrade to 2017",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2018,
            tilte: "Upgrade to 2017",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
        {
            year: 2019,
            tilte: "Upgrade to 2017",
            content: "Director Unit of Shenzhen International Freight Forwarders Association"
        },
    ];

    let currIndex = 0; //记录当前年份卡
    let autoPlayAnimation; // 自动播放动画对象
    let $yearCards: any = $(".qualification-section__year");


    function calcRenderOptionsForWeb() {
        var serviceContainerH = $(".qualification-section__container").height();
        var serviceContainerW = $(".qualification-section__container").width();
        var cardH = serviceContainerH / 5;
        var cardW = serviceContainerH / 5;
        return {
            container: {
                width: serviceContainerW,
                height: serviceContainerH
            },
            card: {
                width: cardW,
                height: cardW
            },
            layer: {
                width: serviceContainerH*2 ,
                height: serviceContainerH*2
            },
            canvas:{
                width:serviceContainerH*2,
                height:serviceContainerH*2,
                circleX:serviceContainerH,
                circleY:serviceContainerH,
                circleR:serviceContainerH-160
            },
            adjust: {
                marginTop: 160,
            }
        }
    }

    function calcRenderOptionsForMobile() {
        var serviceContainerH = $(".qualification-section__container").height();
        var serviceContainerW = $(".qualification-section__container").width();
        var cardH = 80;
        var cardW = 80;
        // var cardH = serviceContainerH / 6;
        // var cardW = serviceContainerH / 6;
        return {
            container: {
                width: serviceContainerW,
                height: serviceContainerH
            },
            card: {
                width: cardW,
                height: cardH
            },
            layer: {
                width: serviceContainerH,
                height: serviceContainerH
            },
            canvas:{
                width:serviceContainerH,
                height:serviceContainerH,
                circleX:serviceContainerH/2,
                circleY:serviceContainerH/2,
                circleR:serviceContainerH/2
            },
            adjust: {
                marginTop: 40,
            }
        }
    }

    /**
     * 计算年份
     * @param currentYear 当前年份 
     * @param count 数量
     * @param dir 方向
     */
    function calcYears(currentYear: number, count: number, dir: "left" | "right") {
    
        const currentYearIndex = honors.findIndex(o => o.year === currentYear)
        let years = [];
        for (var i = 1; i < count; i++) {

            if (dir === "left") {
                if (currentYearIndex - i >= 0) {
                    years.push(currentYearIndex - i);
                } else {
                    years.push(honors.length + currentYearIndex - i);
                }
            } else {
                if (currentYearIndex + i <= honors.length - 1) {
                    years.push(currentYearIndex + i);
                } else {
                    years.push(currentYearIndex + i - honors.length);
                }
            }

        }
        return years.map((o) => honors[o].year);
    }

    /**
     * 更新分布在圆上的所有年份，以便看见区域的年份可以展示所有荣誉列表的所有年份
     * 
     * @param index 当前位置
     */
    function updateYearCards(index: number) {
        const curYear: any = parseInt($($yearCards[index]).text());

        // 更新左侧年份卡文本
        const leftSideYears = calcYears(curYear, 5, "left");
        for (let i = 1; i < 6; i++) {
            let $card: any = null;
            if (index - i >= 0) {
                $card = $($yearCards[index - i]);
            } else {
                $card = $($yearCards[$yearCards.length + index - i]);
            }
            $card.find('.qualification-section__year-text').text(leftSideYears[i - 1]);

            if (i === 1) {
                $card.removeClass("qualification-section__year--future");
            } else {
                $card.addClass("qualification-section__year--future");
            }
        }

        // 更新右侧年份卡片文本
        const rightSideYears = calcYears(curYear, 5, "right");
        for (let i = 1; i < 6; i++) {
            let $card: any = null;
            if (index + i < $yearCards.length) {
                $card = $($yearCards[index + i]);
            } else {
                $card = $($yearCards[index + i - $yearCards.length]);
            }

            $card.find('.qualification-section__year-text').text(rightSideYears[i - 1]);

            if (i === 1) {
                $card.removeClass("qualification-section__year--future");
            } else {
                $card.addClass("qualification-section__year--future");
            }
        }
    }

    /**
     * 设置该位置为当前节点
     * 
     * @param index 位置
     */
    function setCurrent(index: any) {
        //设置年份卡为当前位置
        $yearCards.removeClass("qualification-section__year--active");
        $($yearCards[index]).addClass("qualification-section__year--active");
        $($yearCards[index]).removeClass("qualification-section__year--future");

        // 更新荣誉展示墙展示当前年份的荣誉信息
        const honorNote = honors.find((h) => {
            return h.year === parseInt($($yearCards[index]).text());
        })
        if (honorNote) {
            $(".qualification-section__note-title").text(honorNote.year);
            $(".qualification-section__note-content").text($.i18n('honor-' + honorNote.year));
            $(".qualification-section__note-content").attr('i18n', 'honor-' + honorNote.year);
        }
    }

    /**
     * 旋转指定位置到当前位置
     * 
     * @param index  指定位置
     * @param currIndex 上次一次当前年份卡索引
     * @param $yearCards 年份卡列表
     */
    function rotation(index: number, currIndex: number, $yearCards: any) {
        const cardCount = $yearCards.length;
        const degPerIndex = 360 / cardCount;

        // 计算选择到指定位置的角度
        let toGo;
        let layerRotation: string;
        let textRotation: string;
        if (index - currIndex > 0 && index - currIndex < 4 ||
            currIndex - index > 0 && currIndex - index > 6) { // 点击右侧卡片

            toGo = (index - currIndex);
            if (toGo < 1) {
                toGo = cardCount + toGo;
            }

            layerRotation = `-=${toGo * degPerIndex}`;
            textRotation = `+=${toGo * degPerIndex}`;
        } else {
            toGo = (currIndex - index);
            if (toGo < 1) {
                toGo = cardCount + toGo;
            }

            layerRotation = `+=${toGo * degPerIndex}`;
            textRotation = `-=${toGo * degPerIndex}`;
        }

        // 卡片跟容器选择反方向保持文本上下结构展示
        $yearCards.each((i, card) => {
            gsap.to(card, {
                rotation: textRotation,
                ease: "none",
            });
        });

        // 年份层旋转到指定位置
        return gsap.to('.qualification-section__year-layer', {
            rotation: layerRotation,
            ease: "none",
            onComplete: () => {
                if (autoPlayAnimation && autoPlayAnimation.paused()) {
                    autoPlayAnimation.play(-1);
                }
            }
        });
    }


    /**
     * 绘制半圆年份线
     */
    function renderHalfArcYearsLine(renderOptions: any) {
        // 拿到画板
        var canvas: any = document.getElementById('qualification-section__canvas');

        if(renderOptions.container.width<renderOptions.container.height){
            $("#qualification-section__canvas").css("margin-left",-Math.abs(renderOptions.container.height-renderOptions.container.width)/2);
        }else{
            $("#qualification-section__canvas").css("margin-bottom",-Math.abs(renderOptions.container.height-renderOptions.container.width)/2);
            $("#qualification-section__canvas").css("margin-left",(renderOptions.container.width-renderOptions.canvas.width)/2);

        }

        canvas.width = renderOptions.canvas.width;
        canvas.height = renderOptions.canvas.height;

        // 拿到上下文
        var context = canvas.getContext('2d');
        context.strokeStyle = '#656b72';
        context.lineWidth = 24;

        // 绘制弧线
        context.beginPath();
        context.arc(renderOptions.canvas.circleX, renderOptions.canvas.circleY, renderOptions.canvas.circleR, 0, 180, false);
        context.closePath();
        context.stroke();
    }

    /**
     * 绘制年份卡
     */

    function renderYearCards(renderOptions: any) {
        var containerH = renderOptions.container.height;
        $(".qualification-section__year-layer").height(renderOptions.layer.height);
        $(".qualification-section__year-layer").width(renderOptions.layer.height);

        // if(renderOptions.container.width<renderOptions.container.height){
        //     $("#qualification-section__canvas").css("margin-left",-Math.abs(renderOptions.container.height-renderOptions.container.width)/2);
        // }else{
        //     $("#qualification-section__year").css("left",(renderOptions.container.width-renderOptions.canvas.width)/2);
        // }

        if(renderOptions.canvas.width>renderOptions.container.width){
            $(".qualification-section__year-layer").css("left",(renderOptions.container.width-renderOptions.canvas.width)/2);
        }

        $(".qualification-section__year").css("width",renderOptions.card.height);
        $(".qualification-section__year").css("height",renderOptions.card.height);

        //初始化卡片启动位置，防止循环时闪烁
        var path = utils.circle(renderOptions.canvas.circleX-renderOptions.card.height/2, renderOptions.canvas.circleY-renderOptions.card.height/2, renderOptions.canvas.circleR, 0, 360, 36);
        // for(let p of path){
        //     p.x=p.x-renderOptions.card.width/2+10;
        //     p.y=p.y-renderOptions.card.height/2;
        // }

        $yearCards.each(function (i, e) {
            $(e).css("transform", "translate(" + path[i].x + "px, " + path[i].y + "px)");
        });


        var anim = gsap.to({}, {});
        $yearCards.each((i, yearCard) => {
            $(yearCard).click(() => {

                // 动画活动或点击的是当前节点则忽略
                if (anim.isActive() || i === currIndex) {
                    return;
                }

                if (autoPlayAnimation) {
                    autoPlayAnimation.pause(-1);
                }

                //更新年份开片
                updateYearCards(i);

                // 设置当前节点
                setCurrent(i);

                // 旋转当前点击卡片到当前位置
                anim = rotation(i, currIndex, $yearCards);

                currIndex = i;
            });
        });

    }

    /**
     * 自动播放动画
     */
    function autoPlay() {
        autoPlayAnimation = gsap.timeline({
                repeat: -1,
                repeatDelay: 5
            })
            .to({}, {})
            .call(() => {

                let index = currIndex + 1;
                if (index >= $yearCards.length) {
                    index = 0;
                }
                //更新年份开片
                updateYearCards(index);

                // 设置当前节点
                setCurrent(index);

                // 旋转当前点击卡片到当前位置
                rotation(index, currIndex, $yearCards);

                currIndex = index;
            });
    }

    /**
     * 绘制历年荣誉
     */
    function render() {

        var renderOptions;
        if (utils.isMobile.any()) {
            renderOptions = calcRenderOptionsForMobile();
        } else {
            renderOptions = calcRenderOptionsForWeb();
        }

        // 绘制半圆年份线
        renderHalfArcYearsLine(renderOptions);

        // 绘制年份卡
        renderYearCards(renderOptions);
    }


    render();
    autoPlay();
});